import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { site } from "../data/site";

export default function MobileActionBar() {
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-action-bar"
    >
      <a
        href={site.phoneHref}
        data-testid="mobile-call-button"
        className="flex items-center justify-center gap-2 bg-forest-dark text-sand py-4 text-sm font-semibold tracking-wide"
      >
        <Phone size={16} /> Appeler
      </a>
      <Link
        to="/demander-un-devis"
        data-testid="mobile-quote-button"
        className="flex items-center justify-center gap-2 bg-moss text-white py-4 text-sm font-semibold tracking-wide"
      >
        <FileText size={16} /> Demander un devis
      </Link>
    </div>
  );
}
